module.exports = __webpack_public_path__ + "img/bg-growth.1ff4f108.png";